import { Injectable } from '@angular/core';
import { NgbDatepickerConfig, NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { JhiLanguageService } from 'ng-jhipster';
import { LANGUAGES } from '../index';


@Injectable()
export class CustomDateParserFormatterI18n extends NgbDateParserFormatter {

    constructor( private languageService: JhiLanguageService) {
        super();
    }

    parse(value: string): NgbDateStruct {
        if (value) {
            const dateParts = value.trim().split('/');
            if (dateParts.length === 1 && this.isNumber(dateParts[0])) {
                return {year: this.toInteger(dateParts[0]), month: null, day: null};
            } else if (dateParts.length === 2 && this.isNumber(dateParts[0]) && this.isNumber(dateParts[1])) {
                return {year: this.toInteger(dateParts[1]), month: this.toInteger(dateParts[0]), day: null};
            } else if (dateParts.length === 3 && this.isNumber(dateParts[0]) && this.isNumber(dateParts[1])
                && this.isNumber(dateParts[2])) {
                return {year: this.toInteger(dateParts[2]), month: this.toInteger(dateParts[1]), day: this.toInteger(dateParts[0])};
            }
        }
        return null;
    }

    private padNumber(value: number) {
        if (this.isNumber(value)) {
            return `0${value}`.slice(-2);
        } else {
            return '';
        }
    }

    private isNumber(value: any): boolean {
        return !isNaN(this.toInteger(value));
    }

    private toInteger(value: any): number {
        return parseInt(`${value}`, 10);
    }

    format(date: NgbDateStruct): string {
        let stringDate: string = '';

        if ( date ) {
            switch (this.languageService.currentLang) {
                case LANGUAGES[0] :
                    // fr
                    stringDate += this.isNumber(date.day) ? this.padNumber(date.day) + '/' : '';
                    stringDate += this.isNumber(date.month) ? this.padNumber(date.month) + '/' : '';
                    stringDate += date.year;
                break;
                case LANGUAGES[1] :
                    // en
                    stringDate += this.isNumber(date.month) ? this.padNumber(date.month) + '/' : '';
                    stringDate += this.isNumber(date.day) ? this.padNumber(date.day) + '/' : '';
                    stringDate += date.year;
                break;
                case LANGUAGES[2] :
                    // es
                    stringDate += this.isNumber(date.day) ? this.padNumber(date.day) + '/' : '';
                    stringDate += this.isNumber(date.month) ? this.padNumber(date.month) + '/' : '';
                    stringDate += date.year;
                break;
            }
        }
        return stringDate;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/formatters/date-parser.formatter.ts